import React, { memo, useCallback, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { useFormik } from "formik";
import { Upload, Button, Popconfirm, Tooltip, Tag } from "antd";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  ASSIGNEE_TYPE,
  DIGITAL_SIGN_PROVIDER,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DOCUMENT_TYPE,
} from "../../constants";
import AuthoritiesActionModal from "../InternalDocumentOutgoing/AuthoritiesActionModal";
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from "./InternalDocumentOutgoingDocCreatePageStyled";
import {
  DeleteOutlined,
  FileTextOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import utils from "../../utils";
import { toJS } from "mobx";
import PopupRenameFile from "../../components/PopupRenameFile/PopupRenameFile";
import * as yup from "yup";
import { AiOutlineUser } from "react-icons/ai";
import { AvatarHasName } from "../../components/common/Avatar";
import SelectPeoplePopup from "../../components/SelectPeoplePopup/SelectPeoplePopup";
import { SelectList } from "../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled";

const InternalDocumentOutgoingCreate = (props) => {
  const {
    setFilter,
    open,
    handleClose,
    authorityStore,
    bookStore,
    loadingAnimationStore,
    fileStore,
    signedDocumentStore,
    internalDocumentStore,
    createMessage,
    selectPeopleStore,
    check,
    setCheck,
  } = props;
  const { authorityIssuedsList } = authorityStore;
  const [fileList, setFileList] = useState([]);
  const { bookGroupList, bookListOfGroup } = bookStore;
  const { createInternalDocumentOutgoing } = internalDocumentStore;
  const {
    handleOpenSelectUserDepartmentPopup,
    selectUserData,
    handleCancelSelectUserDepartment,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    clearSelectPeopleStore,
    clearSelected,
  } = selectPeopleStore;

  const formik = useFormik({
    initialValues: {
      agency_external: undefined,
      authority_issued_id: undefined,
      book_group_id: undefined,
      book_id: undefined,
      company_code_recipients: undefined,
      date_issued: null,
      document_number: undefined,
      document_type: undefined,
      attachments: [],
      sign_date: null,
      signer: undefined,
      title: undefined,
      urgency_level: undefined,
      agency_issued: undefined,
      assign_user: {
        assignees: [],
      },
    },
    validationSchema: yup.object().shape({
      book_id: yup
        .string()
        .required("Vui lòng chọn sổ văn bản!")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập sổ văn bản!"),
      document_number: yup
        .string()
        .required("Vui lòng nhập số hiệu!")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập số hiệu!"),
      title: yup
        .string()
        .required("Vui lòng nhập trích yếu!")
        .matches(/^(?=.*\S).+$/, "Vui lòng nhập trích yếu!"),
      attachments: yup.array().min(1, "Vui lòng chọn tài liệu đính kèm!"),
    }),
    onSubmit: async (values) => {
      setButtonBlock(true);
      try {
        loadingAnimationStore.showSpinner(true);
        await createInternalDocumentOutgoing(values);
        loadingAnimationStore.showSpinner(false);
        createMessage("Tạo văn bản thành công!", true, "success");
      } catch (err) {
        console.log(err);
      } finally {
        handleCloseForm();
      }
    },
  });

  const handleSelectBookGroupId = async (bookGroupId) => {
    if (!bookGroupId)
      createMessage("Chưa có nhóm sổ văn bản!", true, "warning");
    formik.setFieldValue("book_group_id", bookGroupId);
    loadingAnimationStore.showSpinner(true);
    try {
      const bookListOfGroup = await bookStore.getBookByBookGroupId(bookGroupId);
      formik.setFieldValue("book_id", bookListOfGroup.data[0].id);
    } catch (error) {
      createMessage(error?.vi, true, "error");
    } finally {
      loadingAnimationStore.showSpinner(false);
    }
  };

  const handleSelectBookId = (bookId) => {
    if (!bookId) createMessage("Chưa có sổ văn bản!", true, "warning");
    formik.setFieldValue("book_id", bookId);
  };

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map((file) => file.originFileObj);
    const batchUploadArr = [];
    uploadFileList.forEach((file) => {
      const formData = new FormData();
      formData.append("file", file);
      batchUploadArr.push(fileStore.uploadFile(formData));
    });
    const response = await Promise.all(batchUploadArr);
    const res = response.map((response) => response.data.file_id);
    formik.setFieldValue("attachments", res);
  }, [fileList]);

  useEffect(() => {
    updateAttachments();
  }, [updateAttachments]);

  const [advanceFilterSignD, setAdvanceFilterSignD] = useState({
    date_by: null,
    month: "",
    tag: [],
  });

  const [advanceFilterDI, setAdvanceFilterDI] = useState({
    date_by: null,
    month: "",
    tag: [],
  });

  const handleChangeSignDate = (value) => {
    setAdvanceFilterSignD({
      ...advanceFilterSignD,
      month: value,
    });
    formik.setFieldValue("sign_date", value);
  };

  const handleChangeDateIssued = (value) => {
    setAdvanceFilterDI({
      ...advanceFilterDI,
      month: value,
    });
    formik.setFieldValue("date_issued", value);
  };

  const [selectedOption, setSelectedOption] = useState("");
  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const handleClear = () => {
    setSelectedOption("");
  };

  const [bookGroupId, setBookGroupId] = useState();
  const [bookId, setBookId] = useState();

  useEffect(() => {
    (async () => {
      loadingAnimationStore.showSpinner(true);
      try {
        authorityStore.setAuthorityIssuedsQueryParams({
          type: DOCUMENT_TYPE.OUTGOING,
          key: null,
        });
        await authorityStore.getAuthorityIssueds();
        const responseGetBookGroup = await bookStore.getBookGroup("DI");
        const responseBookByBookGroupId = await bookStore.getBookByBookGroupId(
          responseGetBookGroup.data[0].id
        );
        formik.setFieldValue(
          "book_group_id",
          responseGetBookGroup.data?.length > 0
            ? responseGetBookGroup.data[0].id
            : null
        );
        setBookGroupId(responseGetBookGroup.data[0]?.id);
        formik.setFieldValue(
          "book_id",
          responseBookByBookGroupId.data?.length > 0
            ? responseBookByBookGroupId.data[0]?.id
            : null
        );
        setBookId(responseBookByBookGroupId.data[0]?.id);
      } catch (err) {
        createMessage(err?.vi || "Đã có lỗi xảy ra!", true, "error");
      } finally {
        loadingAnimationStore.showSpinner(false);
      }
    })();
    return () => {
      bookStore.clearStore();
      signedDocumentStore.clearFilePDFSign();
    };
  }, []);

  const authorityIssuedId = authorityIssuedsList.map(
    (authorityIssued) => authorityIssued.id
  );

  useEffect(() => {
    if (authorityIssuedsList.length === 0)
      formik.setFieldValue("authority_issued_id", null);
    formik.setFieldValue("authority_issued_id", authorityIssuedId[0]);
  }, [authorityIssuedsList]);

  const [isVisibleAuthoritiesActionModal, setIsVisbleAuthoritiesActionModal] =
    useState(false);

  const handleToggleAuthoritiesActionModal = (bool) => (event) => {
    setIsVisbleAuthoritiesActionModal(bool);
  };

  // Set giá trị mặc định là phần tử đầu tiên cho loại văn bản
  useEffect(() => {
    formik.setFieldValue("document_type", "021");
  }, []);

  useEffect(() => {
    if (selectedOption === "" || selectedOption === undefined)
      setSelectedOption(undefined);
    formik.setFieldValue("urgency_level", selectedOption);
  }, [selectedOption]);

  const handleCloseForm = async () => {
    setFilter({
      page: 0,
      size: 10,
      title: null,
      signer: null,
      value: null,
    });
    const responseGetBookGroup = await bookStore.getBookGroup("DI");
    await bookStore.getBookByBookGroupId(responseGetBookGroup.data[0].id);
    setCheck(!check);
    handleClose();
    setButtonBlock(false);
    formik.setErrors({});
    formik.setTouched({});
    formik.setFieldValue("book_group_id", bookGroupId);
    formik.setFieldValue("book_id", bookId);
    formik.setFieldValue("document_number", null);
    formik.setFieldValue("document_type", "021");
    formik.setFieldValue("sign_date", null);
    formik.setFieldValue("date_issued", null);
    formik.setFieldValue("signer", "");
    formik.setFieldValue("urgency_level", null);
    formik.setFieldValue("title", null);
    formik.setFieldValue("attachments", null);
    formik.setFieldValue("authority_issued_id", authorityIssuedId[0] || null);
    formik.setFieldValue("agency_issued", null);
    formik.setFieldValue("assign_user", {
      assignees: [],
    });
    setSelectedOption("");
    setAdvanceFilterSignD({ ...advanceFilterSignD, month: "" });
    setAdvanceFilterDI({ ...advanceFilterDI, month: "" });
    setFileList([]);
    setSignerDoc([]);
    clearSelectPeopleStore();
    clearSelected();
  };

  const handleChangeFile = (info) => {
    if (info.fileList.length === 0) {
      formik.setFieldValue("file_upload", undefined);
      setFileList([]);
      return;
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex((file) => file.name === elem.name) === index
    );
    setFileList(filteredFileList);
  };

  const handleRemoveFileFromUploadList = useCallback(
    (fileUID) => {
      const newFileList = fileList.filter((file) => file.uid !== fileUID);
      setFileList(newFileList);
      if (newFileList.length === 0) {
        formik.setFieldValue("attachments", []);
      }
    },
    [fileList]
  );

  const handleSignSavis = (file, index) => {
    loadingAnimationStore.showSpinner(true);
    const formData = new FormData();
    formData.append("file", file.originFileObj);
    fileStore
      .uploadFile(formData)
      .then((res) => {
        const dataSubmit = {
          image: "",
          reason: "Signed",
          location: "VietNam",
          provider: DIGITAL_SIGN_PROVIDER,
          contactInfo: "",
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          isVisible: 1,
          page: 1,
          llx: 0,
          lly: 790,
          urx: 300,
          ury: 750,
          listSignFile: [
            {
              fileId: res.data.file_id,
            },
          ],
        };
        signedDocumentStore
          .signDocumentSavis(dataSubmit)
          .then((res) => {
            const { fileSignId, fileOriginName, fileSignName } =
              res.data.listSignFile[0];
            const newFileList = [...fileList];
            newFileList[index] = {
              name: fileSignName,
              id: fileSignId,
              uid: file.uid,
              isSigned: true,
              type: "application/pdf",
            };
            setFileList(newFileList);
            loadingAnimationStore.showSpinner(false);
            createMessage(
              `Văn bản "${fileOriginName}" đã được kí`,
              true,
              "success"
            ).then();
          })
          .catch((err) => {
            loadingAnimationStore.showSpinner(false);
            return createMessage(err?.vi || "Ký số thất bại!", true, "error");
          });
      })
      .catch(() => loadingAnimationStore.showSpinner(false));
  };

  const handleBeforeSign = (file, index) => {
    setDataSignSavis({
      file: file,
      index: index,
    });
  };

  const [isRenameFileFromTruc, setIsRenameFileFromTruc] = useState(false);
  const [fileExt, setFileExt] = useState(undefined);
  const [fileTargetRename, setFileTargetRename] = useState(null);
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false);
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ["rename"],
      value: "",
    },
  ]);
  const [fileFromTruc, setFileFromTruc] = useState([]);

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.name),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.name));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };

  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  };

  const submitRenameFile = async (value) => {
    const index = fileTargetRename?.index;
    // đổi tên file nhận từ trục
    if (isRenameFileFromTruc) {
      const fileFromTrucAfterRename = [...fileFromTruc];
      fileFromTrucAfterRename[index] = {
        fileId: fileTargetRename.fileId,
        name: value.rename + fileExt,
      };
      setFileFromTruc(fileFromTrucAfterRename);
      setIsModalVisibleRenameFile(false);
      createMessage("Đổi tên file thành công", true, "success");
      return;
    }
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      );
      setFileList(newFileList);
      setIsModalVisibleRenameFile(false);
      createMessage("Đổi tên file thành công", true, "success");
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      );
      setIsModalVisibleRenameFile(false);
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      setFileList(newFileList);
      createMessage("Đổi tên file thành công", true, "success");
    }
  };

  const handleRemoveFileFromTruc = (file_id) => {
    setFileFromTruc(
      toJS([...fileFromTruc]).filter((file) => file.fileId !== file_id)
    );
  };

  const { responseSign } = signedDocumentStore;
  const [dataSignSavis, setDataSignSavis] = useState();

  useEffect(() => {
    if (!responseSign) return;
    const { fileSignId, fileSignName } = responseSign.data.listSignFile[0];
    const newFileList = [...fileList];
    newFileList[dataSignSavis.index] = {
      name: fileSignName,
      id: fileSignId,
      uid: dataSignSavis.file.uid,
      isSigned: true,
      type: "application/pdf",
    };
    setFileList(newFileList);
  }, [responseSign]);

  const [warningSH, setWarningSH] = useState({});

  const validateDocumentNumber = async (e) => {
    formik.handleChange(e);
    if (e.target.value && e.target.value.trim() === "") {
      return Promise.reject("Cần nhập ký tự, vui lòng không bỏ trống");
    } else {
      try {
        const response = await internalDocumentStore.getWarningDocumentNumber(
          formik.values.book_id,
          e.target.value,
          "OUTGOING"
        );
        if (response.data.status === "WARNING") {
          setWarningSH(response.data);
          return Promise.reject(response.data.message);
        } else {
          setWarningSH(response.data);
          return Promise.resolve();
        }
      } catch (error) {
        console.log(error);
        createMessage(error?.vi || "Đã có lỗi xảy ra!", true, "error");
      }
    }
  };

  useEffect(() => {
    formik.setErrors({});
    formik.setTouched({});
    setWarningSH(null);
  }, [open]);

  const [buttonBlock, setButtonBlock] = useState(false);

  const [signerDoc, setSignerDoc] = useState([]);

  useEffect(() => {
    setSignerDoc([...selectUserData[ASSIGNEE_TYPE.SIGNER]]);
  }, [selectUserData]);

  const updateAssignees = useCallback(() => {
    const newAssignees = [...signerDoc].map((el) => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }));
    // formik.setFieldValue("signer", signerDoc ? signerDoc[0]?.full_name : null);
    formik.setFieldValue("assign_user", {
      assignees: newAssignees,
    });
  }, [signerDoc]);

  useEffect(() => {
    updateAssignees();
  }, [updateAssignees]);

  return (
    <Dialog
      open={open}
      onClose={handleCloseForm}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "100vw",
            mx: 0,
            zIndex: 50,
          },
        },
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: "#2C65AC",
          }}
        >
          <span className="font-bold">Tạo mới văn bản đi</span>
        </DialogTitle>
        <DialogContent>
          <div>
            <FormControl variant="standard" sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>
                <span
                  style={{
                    display: "inline-block",
                    color: "#ff4d4f",
                    fontSize: "14px",
                    fontFamily: "SimSun,sans-serif",
                    lineHeight: 1,
                  }}
                >
                  *
                </span>
                <span> Nhóm sổ văn bản</span>
              </InputLabel>
              <Select
                name="book_group_id"
                sx={{ width: "100%" }}
                defaultValue={bookGroupList[0]?.id}
                onChange={(event) => {
                  const bookId = event.target.value;
                  handleSelectBookGroupId(bookId);
                }}
                label="Nhóm sổ văn bản"
              >
                {bookGroupList.map((book) => (
                  <MenuItem key={book.id} value={book.id}>
                    {book.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <FormControl
              variant="standard"
              sx={{ mt: 1, mb: 1, minWidth: "100%" }}
            >
              <InputLabel>
                <span
                  style={{
                    display: "inline-block",
                    color: "#ff4d4f",
                    fontSize: "14px",
                    fontFamily: "SimSun,sans-serif",
                    lineHeight: 1,
                  }}
                >
                  *
                </span>
                <span> Sổ văn bản</span>
              </InputLabel>
              <Select
                name="book_id"
                sx={{ width: "100%" }}
                defaultValue={bookListOfGroup[0]?.id}
                value={formik.values.book_id}
                onChange={(event) => {
                  const bookId = event.target.value;
                  handleSelectBookId(bookId);
                }}
                label={
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        color: "#ff4d4f",
                        fontSize: "14px",
                        fontFamily: "SimSun,sans-serif",
                        lineHeight: 1,
                      }}
                    >
                      *
                    </span>
                    <span>Sổ văn bản</span>
                  </>
                }
                variant="standard"
                error={
                  formik.errors.book_id && formik.touched.book_id ? true : false
                }
              >
                {bookListOfGroup.map((book) => (
                  <MenuItem key={book.id} value={book.id}>
                    {book.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: 1 }}>
            <TextField
              name="document_number"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Số hiệu</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: "center", height: "50px", width: "100%" }}
              onChange={(e) => {
                validateDocumentNumber(e);
              }}
              error={
                (formik.errors.document_number &&
                  formik.touched.document_number) ||
                warningSH?.status === "WARNING"
                  ? true
                  : false
              }
            />
          </div>
          {warningSH?.status === "WARNING" && (
            <span style={{ color: "red" }}>
              Số hiệu văn bản đã sử dụng, vui lòng nhập số hiệu khác!
            </span>
          )}
          <div>
            <FormControl
              variant="standard"
              sx={{ mt: 1, mb: 1, minWidth: "100%" }}
            >
              <InputLabel>
                <span
                  style={{
                    display: "inline-block",
                    color: "#ff4d4f",
                    fontSize: "14px",
                    fontFamily: "SimSun,sans-serif",
                    lineHeight: 1,
                    marginTop: warningSH?.status === "WARNING" && "10px",
                  }}
                >
                  *
                </span>
                <span> Loại văn bản</span>
              </InputLabel>
              <Select
                name="document_type"
                sx={{ width: "100%" }}
                defaultValue={"021"}
                onChange={formik.handleChange}
                label="Loại văn bản"
              >
                <MenuItem value={"021"}>Công văn</MenuItem>
                <MenuItem value={"022"}>Quyết định</MenuItem>
                <MenuItem value={"024"}>Tờ trình</MenuItem>
                <MenuItem value={"020"}>Báo cáo</MenuItem>
                <MenuItem value={"025"}>Khác</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="sign_date"
                label={
                  <>
                    <span> Ngày ký</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={advanceFilterSignD.month}
                onChange={handleChangeSignDate}
                inputFormat="DD/MM/YYYY"
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: "12px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="date_issued"
                label={
                  <>
                    <span> Ngày văn bản</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={advanceFilterDI.month}
                onChange={handleChangeDateIssued}
                inputFormat="DD/MM/YYYY"
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div>
            <FormControl
              variant="outlined"
              sx={{ mt: "14px", minWidth: "100%" }}
            >
              <InputLabel>
                <>
                  <span> Độ khẩn</span>
                </>
              </InputLabel>
              <Select
                name="urgency_level"
                sx={{ width: "100%" }}
                onChange={handleSelectChange}
                label="Độ khẩn"
                value={selectedOption}
              >
                <MenuItem value={""}>Bỏ chọn độ khẩn</MenuItem>
                <MenuItem value={"001"}>Khẩn</MenuItem>
                <MenuItem value={"002"}>Hỏa tốc</MenuItem>
                <MenuItem value={"003"}>Hỏa tốc hẹn giờ</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: "14px" }}>
            <TextField
              name="title"
              id="outlined-multiline-static"
              label={
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Trích yếu</span>
                </>
              }
              multiline
              rows={3}
              // variant="filled"
              sx={{ width: "100%" }}
              onChange={formik.handleChange}
              error={formik.errors.title && formik.touched.title ? true : false}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <Upload
              valuePropName={"fileList"}
              fileList={fileList}
              multiple={true}
              beforeUpload={() => false}
              onChange={handleChangeFile}
              showUploadList={false}
            >
              <Button
                danger={
                  formik.errors.attachments && formik.touched.attachments
                    ? true
                    : false
                }
                style={{
                  color:
                    formik.errors.attachments && formik.touched.attachments
                      ? null
                      : "#fff",
                  backgroundColor:
                    formik.errors.attachments && formik.touched.attachments
                      ? null
                      : "#1677ff",
                  fontSize: "15px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
                icon={<UploadOutlined />}
              >
                <>
                  <span>Chọn tài liệu đính kèm </span>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "18px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                </>
              </Button>
            </Upload>
          </div>
          {
            <UploadFileListWrapper>
              {fileList.map((file, index) => (
                <UploadFileListItem
                  key={file.uid || file.id}
                  isSigned={file.isSigned}
                  isNotPDF={file.type !== "application/pdf"}
                >
                  <FileTextOutlined />
                  <span>{file.name}</span>
                  {file.isSigned ? (
                    <Button
                      className={"digital-signature"}
                      type="text"
                      onClick={() => createMessage("Đã ký!", true, "info")}
                    >
                      Đã ký
                    </Button>
                  ) : file.type !== "application/pdf" ? (
                    <Button
                      className={"digital-signature text-sm"}
                      type="text"
                      onClick={() =>
                        createMessage(
                          "Chỉ ký được file PDF, vui lòng chọn file khác!",
                          true,
                          "info"
                        )
                      }
                    >
                      Ký số
                    </Button>
                  ) : (
                    <Popconfirm
                      placement="top"
                      title={"Hãy chọn loại ký"}
                      cancelText="Ký mặc đinh"
                      onCancel={() => handleSignSavis(file, index)}
                    >
                      <Button
                        className={"digital-signature text-sm"}
                        type="text"
                        onClick={() => handleBeforeSign(file, index)}
                      >
                        Ký số
                      </Button>
                    </Popconfirm>
                  )}
                  {
                    <Button
                      className={"rename text-sm"}
                      type="text"
                      onClick={() => {
                        setIsRenameFileFromTruc(false);
                        handleOpenPopupRenameFile(file, index);
                      }}
                    >
                      Đổi tên
                    </Button>
                  }
                  <Tooltip title={"Xoá tập tin"}>
                    <DeleteOutlined
                      className="text-sm"
                      onClick={() =>
                        handleRemoveFileFromUploadList(file.uid, index)
                      }
                    />
                  </Tooltip>
                </UploadFileListItem>
              ))}
              {fileFromTruc.map((file, index) => (
                <UploadFileListItem key={file.fileId}>
                  <FileTextOutlined style={{ color: "1890FF" }} />
                  <span style={{ color: "#1890FF" }}>{file.name}</span>
                  <Button
                    className={"rename"}
                    type="text"
                    onClick={() => {
                      setIsRenameFileFromTruc(true);
                      handleOpenPopupRenameFile(file, index);
                    }}
                  >
                    Đổi tên
                  </Button>
                  <Tooltip title={"Xoá tập tin"}>
                    <DeleteOutlined
                      onClick={() =>
                        handleRemoveFileFromTruc(file.fileId, index)
                      }
                    />
                  </Tooltip>
                </UploadFileListItem>
              ))}
            </UploadFileListWrapper>
          }
          {/* <div style={{ display: "flex" }}>
            <label style={{ margin: "5px" }}>Người ký:</label>
            <div>
              <Button
                style={{
                  color: "#ffb100",
                  margin: "5px",
                  border: "1px solid blue",
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.SIGNER)
                }
              >
                <AiOutlineUser />
              </Button>
              <div>
                {signerDoc.map((el) => (
                  <SelectList>
                    <Tag
                      className={"tag-selected"}
                      color={"blue"}
                      key={el.id}
                      onClick={() => selectPeopleStore.handleRemoveSelect(el)}
                    >
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                      />
                    </Tag>
                  </SelectList>
                ))}
              </div>
            </div>
          </div> */}
          <div style={{ marginTop: "12px" }}>
            <TextField
              name="signer"
              id="outlined-multiline-static"
              label=" Người ký"
              // variant="filled"
              sx={{ width: "100%" }}
              onChange={formik.handleChange}
            />
          </div>
          <div style={{ display: "flex" }}>
            <FormControl variant="outlined" sx={{ mt: "12px", width: "100%" }}>
              <InputLabel>
                <>
                  <span
                    style={{
                      display: "inline-block",
                      color: "#ff4d4f",
                      fontSize: "14px",
                      fontFamily: "SimSun,sans-serif",
                      lineHeight: 1,
                    }}
                  >
                    *
                  </span>
                  <span> Thông tin nơi nhận</span>
                </>
              </InputLabel>
              <Select
                name="authority_issued_id"
                sx={{ width: "100%" }}
                defaultValue={authorityIssuedsList[0]?.id}
                onChange={formik.handleChange}
                label="Thông tin nơi nhận"
              >
                {authorityIssuedsList.map((authorityIssued) => (
                  <MenuItem key={authorityIssued.id} value={authorityIssued.id}>
                    {authorityIssued.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              style={{
                color: "#fff",
                backgroundColor: "#1677ff",
                marginTop: "12px",
                marginLeft: "5px",
                width: "91px",
                height: "56px",
              }}
              onClick={handleToggleAuthoritiesActionModal(true)}
            >
              <span style={{ fontSize: "15px" }}>Tạo mới</span>
            </Button>
          </div>
          <div style={{ marginTop: "14px" }}>
            <TextField
              name="agency_issued"
              id="outlined-multiline-static"
              label={
                <>
                  <span> Nhập thông tin nơi nhận</span>
                </>
              }
              multiline
              rows={3}
              // variant="filled"
              sx={{ width: "100%" }}
              onChange={formik.handleChange}
            />
          </div>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: "#e3e4e9", position: "sticky", bottom: 0 }}
        >
          <Button
            sx={{ fontWeight: 600 }}
            type="button"
            onClick={handleCloseForm}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary"
          >
            ĐÓNG
          </Button>
          {buttonBlock || warningSH?.status === "WARNING" ? (
            <button
              disabled={true}
              sx={{ fontWeight: 600 }}
              className="opacity-[0.3] uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]"
            >
              {" "}
              Tạo mới
            </button>
          ) : (
            <button
              type="submit"
              sx={{ fontWeight: 600 }}
              className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]"
            >
              {" "}
              Tạo mới
            </button>
          )}
        </DialogActions>
      </form>
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
      {isVisibleAuthoritiesActionModal && (
        <AuthoritiesActionModal
          createMessage={createMessage}
          disabledAuthoritiesTypePicker
          tabActive={DOCUMENT_TYPE.OUTGOING}
          payloadModal={{
            status: true,
            isCreate: true,
            updatePayLoad: null,
          }}
          handleCloseModal={handleToggleAuthoritiesActionModal(false)}
        />
      )}
      <SelectPeoplePopup
        onlyOneUser
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
    </Dialog>
  );
};

export default memo(
  inject(
    "authorityStore",
    "bookStore",
    "loadingAnimationStore",
    "commonStore",
    "fileStore",
    "signedDocumentStore",
    "internalDocumentStore",
    "selectPeopleStore"
  )(observer(InternalDocumentOutgoingCreate))
);
